<template>
<!-- eslint-disable max-len -->
<edit-page
  name="Metric"
  model-name="metric"
  param="metricId"
  page-prefix="/blade/metrics"
  :create="createMetric"
  :fetch="getMetric"
  :fetch-types="getMetricTypes"
  :update="updateMetric"
  :remove="deleteMetric"
  :enum-names="['metricTypes', 'metrics',]"
  :stub="metric"
  :validator="validator">
<template slot-scope="{ model: metric, enums: { metricTypes, metrics }, validator }">
  <div class="form-row">
    <select-input class="col-sm-2" v-model="metric.type" :validator="validator.type" :options="metricTypes" required autofocus label>Type / Visibility</select-input>

    <number-input class="col-sm-2" v-model="metric.min" label>Min</number-input>

    <number-input class="col-sm-2" v-model="metric.max" label>Max</number-input>

    <number-input class="col-sm-2" v-model="metric.mean" label>Mean</number-input>

    <number-input class="col-sm-2" v-model="metric.standardDeviation" label>Standard Deviation</number-input>
  </div>
  <div class="form-row">
    <checkbox-input class="col-sm-2" v-model="metric.percentage" inline>Percentage</checkbox-input>

    <checkbox-input class="col-sm-2" v-model="metric.integer" inline>Display As Integer</checkbox-input>

    <checkbox-input class="col-sm-2" v-model="metric.hidden" inline>Hidden</checkbox-input>
  </div>

  <text-input label v-model.trim="metric.name" :validator="validator.name" required>Name</text-input>

  <text-input label v-model.trim="metric.title" :validator="validator.title" required>Title</text-input>

  <text-input
    label
    v-model.trim="metric.referenceId"
  >Reference ID (optional, used by text replacements, needs to be unique for a given playthrough)</text-input>

  <text-input label v-model.trim="metric.description">Description</text-input>

  <checkbox-input
    v-if="metric.type === 'team'"
    class="col-sm-2"
    v-model="metric.computed"
  >Computed</checkbox-input>

  <array-input
    v-if="metric.computed && metric.type === 'team'"
    :items="metric.dependentMetrics"
    :disabled="validator.dependentMetrics.$invalid"
    :hide-button="metric.dependentMetrics.length >= validDependentMetrics(metrics, metric).length"
  >
    <h5 slot="title">Metrics To Compute From</h5>

    <div class="form-row" slot="item" slot-scope="{ item: dependentMetric, index: i }">
      <select-input
        class="col-sm-6"
        v-model="dependentMetric._id"
        :validator="validator.dependentMetrics.$each[i]._id"
        :options="unused(validDependentMetrics(metrics, metric)).by('_id').in(metric.dependentMetrics).by('_id').at(i)"
        use="_id"
        :display="m => { return `${m.name} (${m.type})`; }"
        required
        autofocus
        :remove="() => { metric.dependentMetrics.splice(i, 1); }"
        :to="(id) => { return `/blade/metrics/${id}/edit`; }"
      >
        Metric
      </select-input>
    </div>
    <span slot="button">Add Metric</span>
  </array-input>

  <checkbox-input class="col-sm-2" v-model="metric.displayAsDate">Display As Date</checkbox-input>

  <array-input
    v-if="!(metric.displayAsDate)"
    :items="metric.displayValues"
  >
    <h5 slot="title">Display Values</h5>

    <div class="form-row" slot="item" slot-scope="{ item: displayValueMapping, index: i }">
      <number-input
        label
        v-model="displayValueMapping.actualValue"
      >Actual Value</number-input>

      <text-input
        label
        v-model="displayValueMapping.displayValue"
        :remove="() => { metric.displayValues.splice(i, 1); }"
      >Display Value</text-input>
    </div>
    <span slot="button">Add Display Value</span>
  </array-input>
</template>
</edit-page>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';

import { unused } from '../../../utils/utils';

import EditPage from '../../ui/pages/EditPage';
import ArrayInput from '../../ui/inputs/ArrayInput';
import CheckboxInput from '../../ui/inputs/CheckboxInput';
import NumberInput from '../../ui/inputs/NumberInput';
import SelectInput from '../../ui/inputs/SelectInput';
import TextInput from '../../ui/inputs/TextInput';

export default {
  components: {
    EditPage,
    ArrayInput,
    CheckboxInput,
    NumberInput,
    SelectInput,
    TextInput
  },
  data() {
    return {
      utils: {
        unused
      },
      unused,
      // stub used during creation
      metric: {
        _id: '',
        type: '',
        name: '',
        title: '',
        description: '',
        displayValues: [],
        dependentMetrics: [],
        computed: false,
      },
      validator: {
        type: { required },
        name: { required },
        title: { required },
        dependentMetrics: {
          $each: {
            _id: { required },
          },
        },
      },
    };
  },
  methods: {
    ...mapActions([
      'getMetric',
      'getMetricTypes',
      'createMetric',
      'updateMetric',
      'deleteMetric',
    ]),
    validDependentMetrics(metrics, metric) {
      return metrics.filter(m => m.type === metric.type);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/blade/pages/MetricEdit.vue